import React, { useState } from 'react';

import ModalContainer from '@/components/modals/ModalContainer';

const FallbackUI = ({ error, onClose, onSubmitIssue }) => {
	const [isSubmitted, setIsSubmitted] = useState(false);

	const handleSubmit = () => {
		onSubmitIssue?.();
		setIsSubmitted(true);
	};

	return (
		<ModalContainer onCloseModal={onClose} className="error-popup-modal">
			<div className="common-popup error-popup ">
				<div className="common-popup-body text-center py-5">
					<h1 className="red regular-16 weight-500 mb-3">
						Something went wrong while loading the page
					</h1>
					<p className="red regular-14 weight-400">
						Issue details: {error?.message || 'Unknown error occurred'}
					</p>
					{isSubmitted && (
						<p className="green regular-14 weight-500 mt-3">
							✓ Thank you! We will resolve the issue as soon as possible.
						</p>
					)}
				</div>
				<div className="modal-footer">
					<button
						className="button outline size32 ml-2"
						onClick={() => {
							window.location.replace('/');
						}}
					>
						Reload
					</button>

					<button className="button size32 ml-2" onClick={handleSubmit} disabled={isSubmitted}>
						{isSubmitted ? 'Issue Submitted' : 'Issue submit to system QA'}
					</button>
				</div>
			</div>
		</ModalContainer>
	);
};
export default FallbackUI;
